import React from 'react';

const Tab1 = () => {
    return (
        <div>
            <div className='grid md:grid-cols-2 mt-20'>
                <div className=''>
                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2010 - Present</h3>
                        <h1 className='text-4xl font-bold'>Education Quality</h1>

                    </div>

                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Diploma in Mechanical Engineering</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Dinajpur Polytechnic Institute</p>

                                    <p className="text-[#878E99] text-lg mb-6">I was Joined Mechanical Engineering Programe when I don't know what is coding and what is Programming. But When I have known what's Programming then I loved coding and make my skills in this field</p>

                                </div>
                            </div>
                        </li>


                    </ol>
                </div>

                <div>


                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2020 - Present</h3>
                        <h1 className='text-4xl font-bold'>Skills Quality</h1>


                    </div>


                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Web Design</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Learning and Earning Development Project (LEDP - 2020)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I have Completed Web Design Course from Learning and Earning Development Project (LEDP). I have learned there html,css,bootstrap and WordPress.</p>

                                </div>
                            </div>
                        </li>

                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Complete Web Development</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Programming Hero (2020)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I have Completed Web Development Course from oject Programming Hero. I have learned there html,css,bootstrap, tailwindcss, javascript,react.js,node.js,express.js,mongoDB,git and github, authentication etc.</p>

                                </div>
                            </div>
                        </li>

                    </ol>
                </div>

            </div>
        </div>
    );
};

export default Tab1;